/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getAllDistrictStates,
  getDistrictListPagination,
  manageDistrict,
  resetDistrict,
  resetDistrictList,
} from "../actions/masterManagementAction";
import masterLabels from "../labels/master_en.json";
import commonLabels from "../../../common/labels/common_en.json";
import TablePagination from "../../../common/components/TablePagination";
import ConfirmationDialog from "../../../common/components/ConfirmationDialog";
import DistrictForm from "./DistrictForm";
import { toastr } from "react-redux-toastr";
import Select from "react-select";

const DistrictList = () => {
  let rowPerPage = 10;
  const dispatch = useDispatch();
  let [addDistrict, setAddDistrict] = useState({
    Mode: false,
    districtState: "",
    divisionId: "",
    districtCode: "",
    districtName: "",
  });
  let [searchMode, setSearchMode] = useState(false);
  let [districtCode, setDistrictCode] = useState("");
  let [districtName, setDistrictName] = useState("");
  let [districtState, setDistrictState] = useState(false);
  let [divisionId, setDivisionId] = useState(false);
  let [flgDomicile, setFlgDomicile] = useState(false);
  let [listCurrentPage, setListCurrentPage] = useState(0);
  let [showModal, setShowModal] = useState(false);
  let [deleteDistrict, setDeleteDistrict] = useState(0);

  useEffect(() => {
    dispatch(getAllDistrictStates());
    dispatch(resetDistrict());
    dispatch(resetDistrictList());
    setDistrictName("");
    // eslint-disable-next-line
  }, []);

  const inputRef = useRef();

  const onDistrictStateChange = (e) => {
    dispatch(resetDistrict());
    dispatch(resetDistrictList());
    setFlgDomicile(false);
    setDistrictName("");
    setDivisionId("");
    districtStateChange(e);
  };

  const districtStateChange = (e) => {
    let districtSelectedState = e.target.value;
    let districtNameTemp = "";
    setDistrictState(districtSelectedState);
    dispatch(
      getDistrictListPagination(
        0,
        rowPerPage,
        districtSelectedState,
        districtNameTemp
      )
    );
  };

  const searchData = (textToSearch) => {
    setSearchMode(Number(new Date()));
    districtState &&
      dispatch(
        getDistrictListPagination(0, rowPerPage, districtState, textToSearch)
      );
    !districtState && toastr.error(commonLabels.SEARCH_VALIDATION_ERROR);
  };

  const { districtStatesList, districtList, districtPageNoCounter } =
    useSelector((state) => state.masterManagementReducer, shallowEqual);
  let tableCounter = districtPageNoCounter + 1;

  const manageDistrictData = (id) => {
    setShowModal(true);
    setDeleteDistrict(id);
  };

  const deleteDistrictData = (id) => {
    setShowModal(false);
    let requestBody = {
      district: {
        code: id,
        isDeleted: true,
      },
    };
    let totalRecords = districtList.totalNumberOfRecords;
    let remainder = totalRecords % rowPerPage;

    if (remainder == 1) {
      listCurrentPage = listCurrentPage - 1;
    }

    setListCurrentPage(listCurrentPage);
    dispatch(
      manageDistrict(
        requestBody,
        rowPerPage,
        listCurrentPage,
        districtState,
        districtName
      )
    );
  };

  const activeDistrict = (id, isActive) => {
    let requestBody = { district: { code: id, isActive: !isActive } };
    dispatch(
      manageDistrict(
        requestBody,
        rowPerPage,
        listCurrentPage,
        districtState,
        districtName
      )
    );
  };

  const districtStateOptions =
    districtStatesList?.stateDtoList?.map((el) => ({
      value: el.code,
      label: el.name,
    })) || [];

  return addDistrict.Mode != false ? (
    <div>
      <DistrictForm
        addDistrict={addDistrict}
        setAddDistrict={setAddDistrict}
        setDistrictState={setDistrictState}
        districtCode={districtCode}
        districtName={districtName}
        districtState={districtState}
        divisionId={divisionId}
        flgDomicile={flgDomicile}
        setDivisionId={setDivisionId}
        setDistrictCode={setDistrictCode}
        setDistrictName={setDistrictName}
      />
    </div>
  ) : (
    <div className="border border-light w-100 p-4">
      <div className="form-group">
        <div className="d-flex align-items-center gap-4">
          <label className="font-weight-bold float-lect">
            {masterLabels.districtList.States}
            <span className="redColor">*</span>
          </label>
          <div className="col-md-2">
            {/* <select
              className='form-control'
              name="districtState"
              onInput={onDistrictStateChange}
              ref={inputRef}
              defaultValue={addDistrict && addDistrict.districtState}
            >
              <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
              {districtStatesList && districtStatesList.stateDtoList && districtStatesList.stateDtoList.length > 0 && districtStatesList.stateDtoList.map((element, index) =>
                <option key={index} value={element.code}>{element.name}</option>
              )}
            </select> */}

            <Select
              name="districtState"
              options={districtStateOptions}
              onChange={(selectedOption) => {
                onDistrictStateChange({
                  target: {
                    name: "districtState",
                    value: selectedOption?.value || "",
                  },
                });
              }}
              value={
                districtStateOptions.find(
                  (option) =>
                    option.value ===
                    (addDistrict?.districtState || districtState)
                ) || null
              }
              placeholder={commonLabels.COMBO_SELECT}
              isClearable
              ref={inputRef}
            />
          </div>
          <div className="col-md-3">
            <input
              type="text"
              className="form-control"
              name="districtName"
              value={districtName}
              placeholder={masterLabels.districtList.Search_Label}
              onChange={(event) => {
                setDistrictName(event.target.value);
                setSearchMode(false);
              }}
              maxLength="50"
            />
          </div>
          <div className="col-md-1">
            <button
              className="form-control  btn btn-primary custom_button  button_search  "
              onClick={() => {
                searchData(districtName);
              }}
            >
              <i className="fa fa-search" type="button"></i>
            </button>
          </div>
          <div className="col-md-2 text-right">
            <button
              className="form-control  btn btn-primary custom_button   "
              onClick={() => {
                setDistrictName("");
                setAddDistrict({ Mode: "Add" });
              }}
            >
              {masterLabels.districtList.Add_District}
            </button>
          </div>
        </div>
      </div>
      <br />
      <div className="form-group">
        {districtList && districtList.totalNumberOfRecords > 0 ? (
          <div className="row">
            <div className="col-md-12">
              <table className="table table-bordered">
                <thead className="thead-light">
                  <tr>
                    {/* <th scope="col" className='w-10 text-center'>{masterLabels.districtList.No}</th> */}
                    <th scope="col" className="w-10 text-center">
                      {masterLabels.districtList.District_Code}
                    </th>
                    <th scope="col" className="w-80 text-left">
                      {masterLabels.districtList.District_Name}
                    </th>
                    <th scope="col" className="w-10 text-center">
                      {masterLabels.districtList.Action}
                    </th>
                  </tr>
                </thead>
                <tbody className="small">
                  {districtList &&
                    districtList.districtList &&
                    districtList.districtList.map((element, index) => {
                      if (element) {
                        return (
                          <tr key={index}>
                            {/* <td className="text-center">{tableCounter++}</td> */}
                            <td className="text-center">{element.code}</td>
                            <td className="text-left">{element.name}</td>
                            <td className="text-center">
                              <i
                                role="button"
                                data-toggle="tooltip"
                                title={commonLabels.BUTTON_EDIT}
                                className="text-primary fa fa-edit"
                                onClick={() => {
                                  setAddDistrict({
                                    Mode: "Edit",
                                    flgDomicile: element.flg_domicile,
                                    code: element.code,
                                    districtState: element.statecode,
                                    districtName: element.name,
                                    divisionId: element.divisionid,
                                  });
                                }}
                              ></i>
                              &nbsp;&nbsp;
                              <i
                                role="button"
                                data-toggle="tooltip"
                                title={
                                  element.isActive
                                    ? commonLabels.BUTTON_INACTIVE
                                    : commonLabels.BUTTON_ACTIVE
                                }
                                className={
                                  element.isActive === true
                                    ? "text-success fa fa-toggle-on"
                                    : "text-danger fa fa-toggle-off"
                                }
                                onClick={(e) => {
                                  activeDistrict(
                                    element.code,
                                    element.isActive
                                  );
                                }}
                              ></i>
                              &nbsp;&nbsp;
                              <i
                                role="button"
                                data-toggle="tooltip"
                                title={commonLabels.BUTTON_DELETE}
                                className="text-danger fa fa-trash"
                                onClick={(e) => {
                                  manageDistrictData(element.code);
                                }}
                              ></i>
                            </td>
                          </tr>
                        );
                      }
                    })}
                </tbody>
              </table>
              {districtList && districtState && (
                <TablePagination
                  paginationFor="district_list"
                  rowPerPage={rowPerPage}
                  setListCurrentPage={setListCurrentPage}
                  searchCode2={districtState}
                  textToSearch={districtName}
                  searchMode={searchMode}
                  totalCount={districtList.totalNumberOfRecords}
                />
              )}
            </div>
          </div>
        ) : (
          <div className="text-center">
            <font className="text-danger">
              {districtState && commonLabels.NO_DATA_FOUND}
              {!districtState &&
                masterLabels.districtList.Select_State_To_Fetch_Result}
            </font>
          </div>
        )}
      </div>
      {
        <ConfirmationDialog
          showModal={showModal}
          Title={commonLabels.CONFIRMATION_MODAL_TITLE}
          Message={commonLabels.CONFIRMATION_MESSAGE}
          setShowModal={setShowModal}
          deleteRecord={deleteDistrictData}
          deletedId={deleteDistrict}
          IsConfirmation={"true"}
        />
      }
    </div>
  );
};

export default DistrictList;
